import { Paper } from "@mui/material";
import { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import Dimen from "../Dimen";
import { paperStyleDefault } from "../Style";

const PrivacyPolicy: FunctionComponent = () => {
  return (
    <div>
      <Paper
        elevation={3}
        style={{
          margin: Dimen.MarginDefault,
          fontSize: Dimen.FontSizeDefault,
          ...paperStyleDefault,
        }}
      >
        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy" />
        </div>
        <FormattedMessage id="privacy.policy.intro" values={{ br: <br /> }} />

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.infocollection" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.infocollection.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.disclosure" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.disclosure.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.dataretention" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.dataretention.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.ad" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.ad.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.cookie" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.cookie.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.communication" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.communication.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.governinglaw" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.governinglaw.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.modification" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.modification.text" />
        </p>

        <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
          <FormattedMessage id="privacy.policy.optout" />
        </div>
        <p>
          <FormattedMessage id="privacy.policy.optout.text" />
        </p>
      </Paper>
    </div>
  );
};

export default PrivacyPolicy;
